/* eslint-disable */

export default {
  status: 200,
  data: {
    status: true,
    data: {
      images: {
        id: 96146,
        background: [],
        cover_page: [],
        cover_video: [],
        images_page: []
      },
      email_owner: "dpatino@itereo.travel",
      itineraries: [
        {
          id: 4771663,
          days: [
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free time in the Bavarian capital.",
              textday: [
                {
                  textday:
                    "Munich embraces the holiday season with a particular zeal, so the day is all yours to enjoy the vibrant festive markets that abound in this city. On crisp winter days, organ music and carols ring out from the ancient churches. If snow has fallen, the vast English Garden provides lovely winter vistas. Another option is to experience the romantic royal palaces of the Bavarian Alps.(Breakfast)"
                }
              ],
              duration: 1,
              idimagen: 8937,
              startday: 1,
              locations: [
                {
                  code: "DE-MUC",
                  name: "Munich  - Germany",
                  order: 1,
                  location_latitude: 48.13642,
                  location_longitude: 11.57755
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-09-30",
              enddate: "2021-10-01",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/350x240/Munich - Christmas Markets.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1200x725/Munich - Christmas Markets.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1600x900/Munich - Christmas Markets.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free Time in Seville.",
              textday: [
                {
                  textday:
                    "Enjoy a relaxed start and a day to relax, shop or continue exploring this fascinating city at your own pace. Our suggestion is to join an Optional Experience to the ancient city of C&oacute;rdoba, where you will visit the magnificent Mezquita, see the old Jewish Quarter, and enjoy some free time to shop or explore as you wish. Visit Cristina Heeren Foundation, a beneficiary of a TreadRight Foundation grant. This private dance school is dedicated to promoting the conservation of flamenco and supports young enthusiasts from all over the world with a special focus on new talent from the Andalusian region. Feel the passion behind the choreography as you put your rhythm to the test during a dance lesson before witnessing emotions come to life in a flamenco performance. With some free time for dinner, head next door to Triana market and stroll through the many colourful stalls where vendors are selling tapas made from fresh, local produce. Why not grab yourself a refreshing sangria for a cheers to your new found dancing feet?"
                }
              ],
              duration: 1,
              idimagen: 9807,
              startday: 2,
              locations: [
                {
                  code: "ES-SVQ",
                  name: "Seville - Spain",
                  order: 1,
                  location_latitude: 37.38788,
                  location_longitude: -6.00197
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-01",
              enddate: "2021-10-02",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/350x240/Seville3.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/1200x725/Seville3.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/1600x900/Seville3.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Dinner with Wine"
                }
              ],
              title: "Welcome to Madrid.",
              textday: [
                {
                  textday:
                    "Your airport transfer departs Madrid airport for your hotel at 09:00, 11:30, 13:30 or 16:00. The rest of the day is at leisure to begin to get to know this stylish city. At 18:00, join your Travel Director for your Welcome Dinner at a local restaurant and enjoy the opportunity to get to know your fellow travellers over a delightful evening of good food and wine. During your time in Madrid you will travel along the main historical areas in the Capital of Spain known as Madrid of the Bourbons. Your drive will take you through the Old Quarter discovering the origins of the city."
                }
              ],
              duration: 1,
              idimagen: 5344,
              startday: 3,
              locations: [
                {
                  code: "ES-MAD",
                  name: "Madrid - Spain",
                  order: 1,
                  location_latitude: 40.41956,
                  location_longitude: -3.69196
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-02",
              enddate: "2021-10-03",
              url_image: "",
              url_image_1200_725: "",
              url_image_1600_900: "",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free time in the Bavarian capital.",
              textday: [
                {
                  textday:
                    "Munich embraces the holiday season with a particular zeal, so the day is all yours to enjoy the vibrant festive markets that abound in this city. On crisp winter days, organ music and carols ring out from the ancient churches. If snow has fallen, the vast English Garden provides lovely winter vistas. Another option is to experience the romantic royal palaces of the Bavarian Alps."
                }
              ],
              duration: 0,
              idimagen: 8938,
              startday: 4,
              locations: [
                {
                  code: "DE-MUC",
                  name: "Munich  - Germany",
                  order: 1,
                  location_latitude: 48.13642,
                  location_longitude: 11.57755
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-03",
              enddate: "2021-10-03",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/350x240/Munich - Christmas Markets_1.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1200x725/Munich - Christmas Markets_1.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1600x900/Munich - Christmas Markets_1.jpeg",
              image_duplicated: false
            }
          ],
          endplace: null,
          triptype: "",
          tourstyle: "",
          book_group:
            "<p>Please complete and return via email to us.</p>\n\n<p>Trip Name:_________________________________</p>\n\n<p>Trip Date: _____________</p>\n\n<p>Reference Number:____________________________</p>\n\n<p>Number of Expected Guests for Land:_____________</p>\n\n<p>Requested number of Twin Rooms:_____________</p>\n\n<p>Requested number of Triple Rooms:_____________</p>\n\n<p>Requested number of Single Rooms:_____________</p>\n\n<p>Number of Expected Guests for Air:_____________</p>\n\n<p>If airfares are requested, deposit and payment details will be provided upon confirmation of air rates, and schedules.</p>\n\n<p>Receipt of $500 deposit (land only) attached: ☐ (check box) </p>\n\n<p>I have read and accept all the Terms and Conditions:</p>\n\n<p>Agency name:______________________________________</p>\n\n<p>Date:_____________</p>\n\n<p> </p>\n\n<p> </p>\n\n<p> </p>\n\n<p> </p>\n\n<p>Signature:______________________________________</p>\n",
          highlights: [
            {
              id: 4771665,
              items: [
                {
                  id: 4771666,
                  items: "XX breakfasts, XX lunches & XX dinners"
                },
                {
                  id: 4771667,
                  items: "Audio Headsets for flexible sightseeing"
                },
              ],
              title: "Highlights"
            }
          ],
          startplace: null,
          description: "",
          toitinerary: "2021-10-03",
          fromitinerary: "2021-09-30",
          whatsincluded: [
            {
              id: 4771665,
              items: [
                {
                  id: 4771666,
                  items: "XX breakfasts, XX lunches & XX dinners"
                },
                {
                  id: 4771667,
                  items: "Audio Headsets for flexible sightseeing"
                },
                {
                  id: 4771669,
                  items:
                    "Cherry-picked hotels, all tried and trusted (Hotels listed to be used as a guide only and are subject to availability. If the quoted hotel is unavailable, we will secure another hotel in the same category)"
                },
                {
                  id: 4771675,
                  items: "All hotel tips, charges and local taxes"
                }
              ],
              title: "What’s Included"
            }
          ],
          itinerary_code: "CGTTUK00144A",
          notesitinerary: null,
          onlinebookable: 0,
          sellingregions: [
            {
              id: 244,
              order: 1
            }
          ],
          titleitinerary: "Contiki opportunity",
          itinerary_theme: 0,
          letter_itinerary:
            "<p>Dear <strong>XXXXX</strong></p>\n\n<p>Welcome to the art of traveling in style. At Insight Vacations we have been creating magical travel experiences for over 40 years, and we are pleased to offer you this proposal for your upcoming Custom Group on the <strong>XXXXX</strong> departing on the<strong> XXXX.</strong></p>\n\n<p><strong>*Additional notes pertaining to the trip here*</strong></p>\n\n<p>As you have exclusive use of the coach, should you wish to make any changes to the itinerary or inclusions, please let us know and we can tailor the trip to the groups desires.</p>\n\n<p><strong>No hotel space has been booked at this stage, therefore hotels listed in this quotation are to be used as a guide only and subject to change depending on availability at time of reservation. Should the quoted hotel be unavailable we will endeavour to book a similar standard property within the quoted budget.</strong></p>\n\n<p>Prices are based on (<strong>firm 2021 </strong>rates/ <strong>OR</strong> <strong>based on 2021 rates to be used as a guide only, therefore quote will be repriced mid year when firm 2022 pricing is released)</strong>. If accommodation dates fall over any conventions or large scale events, or if particular hotel is required to be contracted, a supplement may be applicable. In these cases, we will notify you when this becomes known to discuss options available to your group. Group hotel space works on a first come first served basis, therefore should you wish to proceed with the proposal we encourage you to let us know as soon as possible so we can commence working on hotel reservations! This process can take some time but we will ensure you are kept up to date. Itinerary maybe subject to change also in some extreme cases where, availability is an issue in a localation quoted.</p>\n\n<p>In this new, fast changing COVID-19 era, we have implemented elevated hygiene and distancing practices to meet new requirements put forth by local governments and health authorities, including the World Health Organization (WHO). These details can be found on our website https://www.insightvacations.com/us/the-insight-difference/well-being. As we adapt to this new world we continue to execute numerous new measures throughout our various guest experiences with the best care and service  possible, to ensure optimum health and well-being for our guests and our team. These new protocols will be adapted and adjusted as needed, in a timely manner, as governments define and introduce what will be required in each country.</p>\n\n<p>As these directives become known and if your group is affected, we will work with you to achieve the best outcome keeping the well-being and peace of mind of our guests as our top priority. Considering the fluidity of situation, the pricing and itinerary, including sightseeing venues, hotels and restaurants are subject to change upon government regulatory changes.</p>\n\n<p>Please read the quotation carefully, and full terms and conditions are also provided here for your reference.</p>\n\n<p>Should you wish to proceed, please process a $500 refundable deposit to us and we will in turn commence making reservations for your group.</p>\n\n<p>Please do not hesitate to contact us for any queries you may have, we are here to help! We look forward to the opportunity of working with you.</p>\n\n<p>Kind regards</p>\n\n<p><strong>XXXXX (insert signature with cta here)</strong></p>\n",
          terms_conditions:
            "<p><strong>BOOKING CONDITIONS:</strong></p><p>Every endeavor is made to ensure all services are included as per your quote request, however it is your responsibility to check all inclusions in the attached itinerary as any items not specified will incur supplementary charged.</p><p>All itineraries/quotation are offered subject to local driver regulations. It is the Tour Directors duty to ensure that driver’s regulations are not broken.</p><p>Please be aware that public holidays, events, conferences or trade fairs may be scheduled to occur at the time of the groups visit and may have an effect on this tour with accommodation often difficult to secure in and around the area. We will update you on these events as they become available.</p><p><strong>Deposits: </strong>A refundable deposit of USD $500 per coach is required to set up the group, this deposit is refundable up to 120 days prior to departure. Non-refundable deposits in the amount of $199 per person are due at 120 days prior to departure. Additional deposits may be required by particular hotels which we secure for the tour. As they become known you will be invoiced accordingly and payment conditions specified.</p><p><strong>Passenger List:</strong> Required to your travel agent no later than 120 days prior to departure.</p><p><strong>Final Payment: </strong>Due in our office by no later than 65 days prior to group departure.</p><p><strong>Invoicing: </strong>Regardless if passenger numbers drop or increase after final payment has been paid to Insight, you will be re-invoiced accordingly, based on full paying passenger numbers traveling, corresponding with the applicable price break quoted. This applies right up until day of departure.</p><p><strong>Price: </strong>All prices for land itineraries are per person in USD and are net (non- commissionable). Unless otherwise stated the pricing is based on twin share accommodation. Prices are based on charges, taxes and levies current at the time of booking and may change if there are significant changes in taxes, charges or levies imposed by any government or its agencies. The price based on minimum passenger numbers and in order for the tour to operate these passenger numbers must be met. Pricing has been provided in tiers based on the number of full paying guests.  If your numbers drop below, the trip will need to be repriced on the applicable tier.  If no tier was provided for the number of paying guests, the trip will need to be repriced.</p><p><strong>Cancellation Fees:</strong></p><p>More than 65 days prior to departure: loss of deposits<br>Between 65 & 31 days prior to departure: 30% of total tour cost<br>Between 30 & 08 days prior to departure: 50% of total tour cost<br>Between 07 days & day of departure: 100% of total tour cost</p><p><strong>Tours with Rail & Cruise:</strong> Additional supplier penalties may apply depending on the date of the cancellation. Individual cancellations may necessitate an adjustment in the per person tour rate.</p><p><strong>Pre/Post Accommodation(s):</strong> Between 14 days and day of departure 100% of accommodation cost.</p><p><strong>Refunds: </strong>No refund is available if cancellations occur after the tour has commenced or in respect of any tours, accommodation, meals or any other services not utilized.</p><p><strong>Itinerary Changes & Tour Cancellation: </strong>Insight Vacations reserves the right to vary itineraries should circumstances dictate, as well as cancel or reschedule any tour departure in accordance with operating requirements, or circumstances beyond its control. Hotels listed are to be used as a guide only unless specified as confirmed. Confirmed hotels are subject to change beyond our control. In this situation we will arrange an alternative property as similar as possible. The advertised tours require minimum numbers to depart. Should these not be met Insight Vacations reserves the right to cancel arrangements.</p><p><strong>Amendments:</strong> A fee of $100 may apply to any change made to your booking once confirmed</p><p><strong>Travel Insurance:</strong> Insight Vacations requires that all guests purchase comprehensive Travel Insurance. Insight Vacations offers comprehensive travel insurance, or this can be purchased independently. Certain countries have a requirement for foreign visitors to have valid medical insurance on entry. Insight Vacations cannot be held responsible for denied entry if a guest is unable to provide details to authorities of insurance or denial of entry for any reason. Please note, travel insurance purchased through us will only cover the amount being charged and collected by Insight Vacations. If Insight Vacations collects a gross amount on your behalf the insurance rate will correspond with the gross amount and the full gross amount will be covered. If Insight Vacations collects a net amount then the insurance rate and coverage will only cover the net amount. Full coverage details can be found on our website.  </p><p><strong>Rooming Arrangements: </strong>Single and Triple rooms are limited. Please advise if the group require more than Three (3) single rooms as these will need to be requested and an additional supplement may apply. Triple rooms are on a request basis and will be subject to availability at the applicable confirmed hotels.</p><p><strong>Tour Membership: </strong>Any person under 18 years of age must be accompanied by an adult. The Tour Director may, at his or her discretion, require any person to withdraw from any tour if he or she deems the person’s acts or conduct offensive or a nuisance to other passengers, and we shall have no further liability.</p><p><strong>Baggage Allowance & Porterage:</strong> Porterage of one suitcase per person is included in the tour price. Due to limited coach capacity the sum of the length, width & depth of the case should not exceed 160cm (63 inches), and weight should not exceed 20kg (44 Lbs). Charges may be levied in the event these limits are exceeded & the promise to transport you may be invalidated.</p><p><strong>What’s Not Included:</strong> Passports and applicable visa fees, laundry, phone calls, items of a personal nature, beverages, meals and sightseeing not detailed on the itinerary, tips and gratuities to the Tour Director, coaches drivers and local city guides, excess baggage, optional experiences and travel insurance. Suggested tip amounts are $7.50, or applicable currency equivalent, per person, per day, suggested for the Travel Director, $4 or applicable currency equivalent, per person, per day, suggested for the Coach Driver and $1 – 2 or applicable currency equivalent per person, per day, suggested for Local Experts. Please note that travel insurance is required per Travel Insurance statement above.</p><p><strong>Documentation: </strong>Electronic travel documents will be emailed approximately 3 weeks prior to departure. Electronic travel documents will be sent to the Agent/Agency email address or to the guests directly upon request, provided accurate email addresses are provided to Insight Vacations.</p><p><strong>Booking Terms and Conditions: </strong>These conditions incorporate the basis upon which bookings are accepted the Travel Agent and Insight Vacations. By making a booking you are agreeing to these terms & conditions. Conditions on this page do supersede conditions stated in the Brochure however for additional terms and conditions not stated here please refer to the ‘Booking Conditions and other Important Information’ pages in the Insight Vacations Brochures or on our website at https://www.insightvacations.com/us/information/booking-conditions. These must be studied prior to making the commitment of paying the deposit as they must be referred to. Additional terms and conditions may be applicable to group bookings and will be advised as they become known</p><p>Quote period of validation: Quote valid within a week of receipt.</p><p> </p>",
          whatsnotincluded: [
            {
              id: 4771676,
              items: [
                {
                  id: 4771677,
                  items: "No early check in/late checkout included."
                },
                {
                  id: 4771678,
                  items: "International, domestic and internal airfares."
                },
                {
                  id: 4771679,
                  items:
                    "Travel insurance, visas and items of a personal nature."
                },
                {
                  id: 4771680,
                  items:
                    "Gratuities to Travel Director, Coach Drivers  and local Experts."
                }
              ],
              title: "What’s not Included"
            }
          ],
          count_days_nights: {
            days: 4,
            nights: 3
          },
          locations_visited: [
            {
              name: "Germany"
            },
            {
              name: "Spain"
            }
          ],
          pricing_itinerary:
            '<div class="table"><table><tbody><tr><th colspan="3"><h2>Quotation</h2><p>Reference: XXXXX Trip Name: XXXXXX: Departure Date XXXX</p><p>Date of quote: XXXXX</p></th></tr><tr><th>35 - 39</th><th>twin share paying guests + 1 FREE twin place</th><th>$XXXX</th></tr><tr><th>30 - 34</th><th>twin share paying guests + 1 FREE twin place</th><th>$XXXX</th></tr><tr><th>25 - 29</th><th>twin share paying guests + 1 FREE twin place</th><th>$XXXX</th></tr><tr><th>20 - 24</th><th>twin share paying guests + 1 FREE twin place</th><th>$XXXX</th></tr><tr><th>15 - 19</th><th>twin share paying guests + 1 FREE twin place</th><th>$XXXX</th></tr><tr><th>10 - 14</th><th>twin share paying guests + 1 FREE twin place</th><th>$XXXX</th></tr><tr><th> </th><th>single room supplement </th><th>$XXXX</th></tr></tbody></table></div><p>The above prices: are based on <strong>firm 2021 pricing / 2021 pricing to be used as a guide only, as will need to be requoted in July when our 2022 pricing is released</strong>. Prices are net per person twin share and guest numbers are shown per coach. No discounts apply.</p><p> </p><p>The above pricing is subject to any additional government taxes and surcharges.</p>',
          approval_signature: [
            {
              id: 4771734,
              name: "Dari",
              last_name: "",
              user_agent:
                "https://itereo-prod-ttc2020.s3.us-east-2.amazonaws.com/signatures/4771663.png",
              local_datetime: "2021-09-10 01:43:05",
              payment_amount: "2500",
              traveler_email: "dpatino@itereo.travel",
              number_of_guests: "12",
              accepted_conditions: 1
            }
          ],
          itinerary_format_type: 27,
          itinerary_source_type: 121,
          itinerary_tracking_id: "",
          locations_visited_coo: [
            {
              id: "4771682",
              lat: "48.13642",
              lng: "11.57755",
              name: "Munich ",
              idloc: "32417",
              duration: 1,
              startday: "1",
              lat_temp: "48.13642",
              lng_temp: "11.57755"
            },
            {
              id: "4771686",
              lat: "37.38788",
              lng: "-6.00197",
              name: "Seville",
              idloc: "41360",
              duration: 1,
              startday: "2"
            },
            {
              id: "4771690",
              lat: "40.41956",
              lng: "-3.69196",
              name: "Madrid",
              idloc: "39938",
              duration: 1,
              startday: "3"
            },
            {
              id: "4771694",
              lat: "48.13642",
              lng: "11.57755",
              name: "Munich ",
              idloc: "32417",
              duration: 0,
              startday: "4"
            }
          ],
          itinerary_source_type_text: "ITP"
        },
        {
          id: 4771698,
          days: [
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free time in the Bavarian capital.",
              textday: [
                {
                  textday:
                    "Munich embraces the holiday season with a particular zeal, so the day is all yours to enjoy the vibrant festive markets that abound in this city. On crisp winter days, organ music and carols ring out from the ancient churches. If snow has fallen, the vast English Garden provides lovely winter vistas. Another option is to experience the romantic royal palaces of the Bavarian Alps.(Breakfast)"
                }
              ],
              duration: 1,
              idimagen: 8937,
              startday: 1,
              locations: [
                {
                  code: "DE-MUC",
                  name: "Munich  - Germany",
                  order: 1,
                  location_latitude: 48.13642,
                  location_longitude: 11.57755
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-09-30",
              enddate: "2021-10-01",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/350x240/Munich - Christmas Markets.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1200x725/Munich - Christmas Markets.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1600x900/Munich - Christmas Markets.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free Time in Seville.",
              textday: [
                {
                  textday:
                    "Enjoy a relaxed start and a day to relax, shop or continue exploring this fascinating city at your own pace. Our suggestion is to join an Optional Experience to the ancient city of C&oacute;rdoba, where you will visit the magnificent Mezquita, see the old Jewish Quarter, and enjoy some free time to shop or explore as you wish. Visit Cristina Heeren Foundation, a beneficiary of a TreadRight Foundation grant. This private dance school is dedicated to promoting the conservation of flamenco and supports young enthusiasts from all over the world with a special focus on new talent from the Andalusian region. Feel the passion behind the choreography as you put your rhythm to the test during a dance lesson before witnessing emotions come to life in a flamenco performance. With some free time for dinner, head next door to Triana market and stroll through the many colourful stalls where vendors are selling tapas made from fresh, local produce. Why not grab yourself a refreshing sangria for a cheers to your new found dancing feet?"
                }
              ],
              duration: 1,
              idimagen: 9807,
              startday: 2,
              locations: [
                {
                  code: "ES-SVQ",
                  name: "Seville - Spain",
                  order: 1,
                  location_latitude: 37.38788,
                  location_longitude: -6.00197
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-01",
              enddate: "2021-10-02",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/350x240/Seville3.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/1200x725/Seville3.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/1600x900/Seville3.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Dinner with Wine"
                }
              ],
              title: "Welcome to Madrid.",
              textday: [
                {
                  textday:
                    "Your airport transfer departs Madrid airport for your hotel at 09:00, 11:30, 13:30 or 16:00. The rest of the day is at leisure to begin to get to know this stylish city. At 18:00, join your Travel Director for your Welcome Dinner at a local restaurant and enjoy the opportunity to get to know your fellow travellers over a delightful evening of good food and wine. During your time in Madrid you will travel along the main historical areas in the Capital of Spain known as Madrid of the Bourbons. Your drive will take you through the Old Quarter discovering the origins of the city."
                }
              ],
              duration: 1,
              idimagen: 5344,
              startday: 3,
              locations: [
                {
                  code: "ES-MAD",
                  name: "Madrid - Spain",
                  order: 1,
                  location_latitude: 40.41956,
                  location_longitude: -3.69196
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-02",
              enddate: "2021-10-03",
              url_image: "",
              url_image_1200_725: "",
              url_image_1600_900: "",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free time in the Bavarian capital.",
              textday: [
                {
                  textday:
                    "Munich embraces the holiday season with a particular zeal, so the day is all yours to enjoy the vibrant festive markets that abound in this city. On crisp winter days, organ music and carols ring out from the ancient churches. If snow has fallen, the vast English Garden provides lovely winter vistas. Another option is to experience the romantic royal palaces of the Bavarian Alps."
                }
              ],
              duration: 0,
              idimagen: 8938,
              startday: 4,
              locations: [
                {
                  code: "DE-MUC",
                  name: "Munich  - Germany",
                  order: 1,
                  location_latitude: 48.13642,
                  location_longitude: 11.57755
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-03",
              enddate: "2021-10-03",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/350x240/Munich - Christmas Markets_1.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1200x725/Munich - Christmas Markets_1.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1600x900/Munich - Christmas Markets_1.jpeg",
              image_duplicated: false
            }
          ],
          endplace: null,
          triptype: "",
          tourstyle: "",
          book_group: "",
          highlights: [
            {
              id: 4771665,
              items: [
                {
                  id: 4771672,
                  items: "All porterage and restaurant gratuities"
                },
                {
                  id: 4771673,
                  items: "Must-see sightseeing and surprise extras"
                },
                {
                  id: 4771674,
                  items: "An expert Travel Director and a professional Driver"
                },
                {
                  id: 4771675,
                  items: "All hotel tips, charges and local taxes"
                }
              ],
              title: "WHAT’S INCLUDED"
            }
          ],
          startplace: null,
          description: "",
          toitinerary: "2021-10-03",
          fromitinerary: "2021-09-30",
          whatsincluded: [],
          itinerary_code: "#TESTCONTIKI3434",
          notesitinerary: null,
          onlinebookable: 0,
          sellingregions: [
            {
              id: 244,
              order: 1
            }
          ],
          titleitinerary: "CONTIKI Test",
          itinerary_theme: 0,
          letter_itinerary: "",
          terms_conditions: "",
          whatsnotincluded: [],
          count_days_nights: {
            days: 4,
            nights: 3
          },
          locations_visited: [
            {
              name: "Germany"
            },
            {
              name: "Spain"
            }
          ],
          pricing_itinerary: "",
          approval_signature: null,
          itinerary_format_type: 27,
          itinerary_source_type: 34919,
          itinerary_tracking_id: "",
          locations_visited_coo: [
            {
              id: "4771700",
              lat: "48.17656296131",
              lng: "11.494757947501",
              name: "Munich ",
              idloc: "32417",
              duration: 1,
              startday: "1",
              lat_temp: "48.17656296131",
              lng_temp: "11.494757947501"
            },
            {
              id: "4771704",
              lat: "37.38788",
              lng: "-6.00197",
              name: "Seville",
              idloc: "41360",
              duration: 1,
              startday: "2"
            },
            {
              id: "4771708",
              lat: "40.41956",
              lng: "-3.69196",
              name: "Madrid",
              idloc: "39938",
              duration: 1,
              startday: "3"
            },
            {
              id: "4771712",
              lat: "48.13642",
              lng: "11.57755",
              name: "Munich ",
              idloc: "32417",
              duration: 0,
              startday: "4"
            }
          ],
          itinerary_source_type_text: "ITP-FLYER"
        },
        {
          id: 4771716,
          days: [
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free time in the Bavarian capital.",
              textday: [
                {
                  textday:
                    "Munich embraces the holiday season with a particular zeal, so the day is all yours to enjoy the vibrant festive markets that abound in this city. On crisp winter days, organ music and carols ring out from the ancient churches. If snow has fallen, the vast English Garden provides lovely winter vistas. Another option is to experience the romantic royal palaces of the Bavarian Alps.(Breakfast)"
                }
              ],
              duration: 1,
              idimagen: 8937,
              startday: 1,
              locations: [
                {
                  code: "DE-MUC",
                  name: "Munich  - Germany",
                  order: 1,
                  location_latitude: 48.13642,
                  location_longitude: 11.57755
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-09-30",
              enddate: "2021-10-01",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/350x240/Munich - Christmas Markets.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1200x725/Munich - Christmas Markets.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1600x900/Munich - Christmas Markets.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free Time in Seville.",
              textday: [
                {
                  textday:
                    "Enjoy a relaxed start and a day to relax, shop or continue exploring this fascinating city at your own pace. Our suggestion is to join an Optional Experience to the ancient city of C&oacute;rdoba, where you will visit the magnificent Mezquita, see the old Jewish Quarter, and enjoy some free time to shop or explore as you wish. Visit Cristina Heeren Foundation, a beneficiary of a TreadRight Foundation grant. This private dance school is dedicated to promoting the conservation of flamenco and supports young enthusiasts from all over the world with a special focus on new talent from the Andalusian region. Feel the passion behind the choreography as you put your rhythm to the test during a dance lesson before witnessing emotions come to life in a flamenco performance. With some free time for dinner, head next door to Triana market and stroll through the many colourful stalls where vendors are selling tapas made from fresh, local produce. Why not grab yourself a refreshing sangria for a cheers to your new found dancing feet?"
                }
              ],
              duration: 1,
              idimagen: 9807,
              startday: 2,
              locations: [
                {
                  code: "ES-SVQ",
                  name: "Seville - Spain",
                  order: 1,
                  location_latitude: 37.38788,
                  location_longitude: -6.00197
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-01",
              enddate: "2021-10-02",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/350x240/Seville3.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/1200x725/Seville3.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/ES/ES-SVQ/1600x900/Seville3.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Dinner with Wine"
                }
              ],
              title: "Welcome to Madrid.",
              textday: [
                {
                  textday:
                    "Your airport transfer departs Madrid airport for your hotel at 09:00, 11:30, 13:30 or 16:00. The rest of the day is at leisure to begin to get to know this stylish city. At 18:00, join your Travel Director for your Welcome Dinner at a local restaurant and enjoy the opportunity to get to know your fellow travellers over a delightful evening of good food and wine. During your time in Madrid you will travel along the main historical areas in the Capital of Spain known as Madrid of the Bourbons. Your drive will take you through the Old Quarter discovering the origins of the city."
                }
              ],
              duration: 1,
              idimagen: 5344,
              startday: 3,
              locations: [
                {
                  code: "ES-MAD",
                  name: "Madrid - Spain",
                  order: 1,
                  location_latitude: 40.41956,
                  location_longitude: -3.69196
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-02",
              enddate: "2021-10-03",
              url_image: "",
              url_image_1200_725: "",
              url_image_1600_900: "",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Free time in the Bavarian capital.",
              textday: [
                {
                  textday:
                    "Munich embraces the holiday season with a particular zeal, so the day is all yours to enjoy the vibrant festive markets that abound in this city. On crisp winter days, organ music and carols ring out from the ancient churches. If snow has fallen, the vast English Garden provides lovely winter vistas. Another option is to experience the romantic royal palaces of the Bavarian Alps."
                }
              ],
              duration: 0,
              idimagen: 8938,
              startday: 4,
              locations: [
                {
                  code: "DE-MUC",
                  name: "Munich  - Germany",
                  order: 1,
                  location_latitude: 48.13642,
                  location_longitude: 11.57755
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2021-10-03",
              enddate: "2021-10-03",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/350x240/Munich - Christmas Markets_1.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1200x725/Munich - Christmas Markets_1.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/DE/DE-MUC/1600x900/Munich - Christmas Markets_1.jpeg",
              image_duplicated: false
            }
          ],
          endplace: null,
          triptype: "",
          tourstyle: "",
          book_group: "",
          highlights: [
            {
              id: 4771665,
              items: [
                {
                  id: 4771666,
                  items: "XX breakfasts, XX lunches & XX dinners"
                },
                {
                  id: 4771667,
                  items: "Audio Headsets for flexible sightseeing"
                },
                {
                  id: 4771668,
                  items:
                    "Luxury air-conditioned coach with WiFi in most countries or alternative transportation (such as rail journeys)"
                },
                {
                  id: 4771669,
                  items:
                    "Cherry-picked hotels, all tried and trusted (Hotels listed to be used as a guide only and are subject to availability. If the quoted hotel is unavailable, we will secure another hotel in the same category)"
                },
                {
                  id: 4771670,
                  items: "Hand-picked Trip Highlights"
                },
                {
                  id: 4771671,
                  items: "Optional Experiences (supplement) and free time"
                },
                {
                  id: 4771672,
                  items: "All porterage and restaurant gratuities"
                },
                {
                  id: 4771673,
                  items: "Must-see sightseeing and surprise extras"
                },
                {
                  id: 4771674,
                  items: "An expert Travel Director and a professional Driver"
                },
                {
                  id: 4771675,
                  items: "Alldddd hotel tips, charges and local taxes"
                }
              ],
              title: "WHAT’S INCLUDED"
            }
          ],
          startplace: null,
          description: "",
          toitinerary: "2021-10-03",
          fromitinerary: "2021-09-30",
          whatsincluded: [],
          itinerary_code: "#TESTCONTIKI3434",
          notesitinerary: null,
          onlinebookable: 0,
          sellingregions: [
            {
              id: 244,
              order: 1
            }
          ],
          titleitinerary: "CONTIKI Test",
          itinerary_theme: 0,
          letter_itinerary: "",
          terms_conditions: "",
          whatsnotincluded: [],
          count_days_nights: {
            days: 4,
            nights: 3
          },
          locations_visited: [
            {
              name: "Germany"
            },
            {
              name: "Spain"
            }
          ],
          pricing_itinerary: "",
          approval_signature: null,
          itinerary_format_type: 27,
          itinerary_source_type: 34920,
          itinerary_tracking_id: "",
          locations_visited_coo: [
            {
              id: "4771718",
              lat: "48.11345576124",
              lng: "11.566369315944",
              name: "Munich ",
              idloc: "32417",
              duration: 1,
              startday: "1",
              lat_temp: "48.11345576124",
              lng_temp: "11.566369315944"
            },
            {
              id: "4771722",
              lat: "37.38788",
              lng: "-6.00197",
              name: "Seville",
              idloc: "41360",
              duration: 1,
              startday: "2"
            },
            {
              id: "4771726",
              lat: "40.41956",
              lng: "-3.69196",
              name: "Madrid",
              idloc: "39938",
              duration: 1,
              startday: "3"
            },
            {
              id: "4771730",
              lat: "48.13642",
              lng: "11.57755",
              name: "Munich ",
              idloc: "32417",
              duration: 0,
              startday: "4"
            }
          ],
          itinerary_source_type_text: "ITP-GUEST"
        }
      ],
      request_form: {
        budget: "",
        foc_places: "",
        group_photo: 0,
        price_break: "",
        airport_arrive: "",
        hotel_standard: 0,
        quote_deadline: "",
        airport_departure: "",
        repeat_guest_gift: 0,
        birthday_allowance: 0,
        td_offer_optionals: 0,
        prebookings_required: 0,
        percentage_commission: 0,
        additional_information: "",
        including_local_guides: 0,
        difficult_dates_checked: 0,
        flourishes_local_treats: 0,
        properties_request_form: {
          id_guests: 0,
          id_supplier: 0,
          id_additional_doc: 0,
          id_stage_supplier: 23,
          id_stage_supplier_old: 23
        },
        gratuities_for_td_driver: 0
      },
      client_details: {
        account_name: "",
        contact_name: "",
        phone_number: "",
        account_email: "",
        account_address: "",
        properties_client: {
          id_type_client: 0
        }
      },
      departure_date: "2021-09-30",
      lastname_owner: "Patiño Panduro",
      firstname_owner: "Dariana",
      selling_regions: [
        {
          id: 244,
          order: 0
        }
      ],
      opportunity_name: "CONTIKI Test",
      reference_number: "#TESTCONTIKI3434",
      template_content: null,
      guest_documentation: {
        id: 96148,
        images: {
          id: 96149,
          background: [],
          cover_page: [],
          cover_video: [],
          images_page: []
        },
        hotel_list:
          '<div class="table"><table><tbody><tr><td><strong>Hotel Palazzo Dei Priori Srl. Siena</strong><br><strong>Country, City</strong><br>Address<br>T: 00-000-0000 F: 00-000-0000</td></tr><tr><td><strong>Hotel Name</strong><br><strong>Country, City</strong><br>Address<br>T: 00-000-0000 F: 00-000-0000</td></tr><tr><td><strong>Hotel Name</strong><br><strong>Country, City</strong><br>Address<br>T: 00-000-0000 F: 00-000-0000</td></tr><tr><td><strong>Hotel Name</strong><br><strong>Country, City</strong><br>Address<br>T: 00-000-0000 F: 00-000-0000</td></tr></tbody></table></div><p><i>Sample</i> </p>',
        introduction: "",
        optional_experience:
          '<div class="table"><table><tbody><tr><td><strong>Spectacular Oia Village Perched On The Caldera Rim</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr><tr><td><strong>Optional Experience Name</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr><tr><td><strong>Optional Experience Name</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr><tr><td><strong>Optional Experience Name</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr></tbody></table></div><p><i>Sample</i></p>'
      },
      properties_opportunity: {
        id: 96139,
        id_brand: 15,
        id_opportunity_status: 5,
        id_opportunity_export_type: 18
      },
      opportunity_details: {
        id_brand: 15,
        departure_date: "2021-09-30",
        opportunity_name: "CONTIKI Test",
        reference_number: "#TESTCONTIKI3434",
        regions: [
          {
            id: 244,
            order: 0
          }
        ],
        types: 18
      },
      consumer_section: {
        images: {
          background: [],
          cover_page: [],
          cover_video: [],
          images_page: []
        }
      },
      created_at: "2021-12-29"
    },
    template: "contiki",
    hash: "f7zu0oV19NZfF-EppTMKSWX3TDIKVTM297t5-9-TikU"
  }
};
